$(document).ready(function () {
    $(document).ready(function () {
        $(".checkout_redesign--half-round").click(function () {
            var animatedContent = $(".checkout_redesign--animated");
            var arrow = $(".checkout_redesign--arrow"); // Selektovanje strelice

            // Proveravamo da li je max-height već postavljen na 70vh
            if (animatedContent.css("max-height") !== "0px") {
                // Ako jeste, 'skupljamo' element postavljanjem max-height na 0
                animatedContent.css("max-height", "0px");
                arrow.css("transform", ""); // Vraćanje strelice na originalnu poziciju
            } else {
                // Ako nije, 'raširujemo' element postavljanjem max-height na 70vh
                animatedContent.css("max-height", "60vh");
                arrow.css("transform", "rotate(180deg)"); // Okretanje strelice
            }
        });
    });
});
